var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStoryCutout = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M11.994 0C13.103 0 14 .898 14 2.006v9.988A2.005 2.005 0 0 1 11.994 14H2.006A2.005 2.005 0 0 1 0 11.994V2.006C0 .897.898 0 2.006 0ZM6.95 3.5c-1.57 0-2.53.935-2.53 2.062 0 2.55 3.84 1.728 3.84 2.906 0 .396-.37.752-1.16.752a2.9 2.9 0 0 1-2.12-.925L4.2 9.423c.63.64 1.55 1.077 2.84 1.077 1.79 0 2.67-.935 2.67-2.174 0-2.53-3.83-1.809-3.83-2.875 0-.407.34-.67.94-.67.68 0 1.4.233 1.94.74l.79-1.076c-.66-.62-1.54-.945-2.6-.945"
})));
export default SvgStoryCutout;